// @flow
import * as React from 'react';
import ChatWelcomeMessage from 'chat_v2/components/ChatWelcomeMessage';
import { MessageNullState } from 'constants/CopyConstants';
// @ts-ignore
import TextWithEntities from 'components/TextWithEntities';
// @ts-ignore
import TextEntities from 'lib/TextEntities';

type Props = {
  stream: *,
};

function getHeader(stream: *) {
  if (stream.streamType === 'chat') {
    const { title } = stream;

    return <div>Hi! This is the beginning of your conversation with {title}.</div>;
  }

  if (stream.streamType === 'entity') {
    return <div>Hi! This is the beginning of your conversation.</div>;
  }

  return null;
}

class StreamHeader extends React.Component<Props, void> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const h1 = getHeader(this.props.stream);
    return (
      <ChatWelcomeMessage
        firstHeader={h1}
        secondHeader={
          <TextWithEntities
            text={MessageNullState.secondHeader}
            entities={TextEntities.parseEmoji(MessageNullState.secondHeader)}
          />
        }
      />
    );
  }
}

export default StreamHeader;
